import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import {
  ProcessingItemState,
  useActionButtonContext,
} from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { fToNow } from '@aibees/shared/utils';
import { useMemo } from 'react';
import { useUnlockPeoplePhoneNumber } from './use-unlock-people-phone-number';

export function usePhoneNumberEnrichmentDescription(data?: PeopleTableInfo) {
  const { getItemState } = useActionButtonContext();
  const { unlocked, loading } = useUnlockPeoplePhoneNumber(data);
  const lastVerifiedDate = data?.revelation?.phone_cached?.created
    ? new Date(data?.revelation?.phone_cached?.created).getTime()
    : 0;

  const phoneNumberEnrichmentProcessState = getItemState({
    id: data?.id || '',
    type: QUICK_INFO_BUTTONS.EMAIL_ENRICHMENT,
  });

  const desc = {
    [ProcessingItemState.UNLOCKING]: 'Unlocking...',
    [ProcessingItemState.REVERIFYING]: 'Re-verifying...',
    [ProcessingItemState.UPDATING]: 'Updating...',
    [ProcessingItemState.CHECKING_FOR_UPDATE]: 'Checking for updates...',
  };

  const loadingText =
    desc[phoneNumberEnrichmentProcessState ?? ProcessingItemState.UNLOCKING];

  return useMemo(
    () =>
      loading
        ? loadingText
        : unlocked
        ? `Last updated ${fToNow(lastVerifiedDate, { strict: false })}`
        : 'Unlock to access Mobile Phone Number',
    [loading, loadingText, unlocked, lastVerifiedDate]
  );
}
